const ENABLED_VALUES = ["true", "1"];

export function isMaintenanceMode(value: string | undefined): boolean {
  return ENABLED_VALUES.includes(value?.trim().toLowerCase() ?? "");
}
